import {
  BACKGROUND,
  BackgroundDefinition,
  BULLET_LIST,
  LayoutHalfPageDefinition,
  LayoutListDefinition,
  LAYOUT_HALF_PAGE,
  LAYOUT_LIST,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { ListHelper } from './itemHelpers/ListHelper';
import { translate } from './translate';

export const List1: Translator = sequence => {
  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'List':
        return {
          id: item.id,
          type: LAYOUT_HALF_PAGE,
          values: {
            side: 'right'
          },
          items: [
            {
              id: item.id,
              type: LAYOUT_LIST,
              values: {
                align: 'left',
                padded: true
              },
              items: [
                {
                  type: TEXT,
                  id: `${item.id}_subtitle`,
                  items: [],
                  values: {
                    value: item.subtitle,
                    variant: 'sub_heading',
                    icon: item?.icon || ''
                  }
                },
                {
                  type: TEXT,
                  id: `${item.id}_title`,
                  items: [],
                  values: {
                    value: item.title,
                    variant: 'heading1'
                  }
                },
                {
                  type: BULLET_LIST,
                  id: item.id,
                  values: [],
                  items: ListHelper(item.items, 'bullet')
                }
              ]
            } as LayoutListDefinition
          ]
        } as LayoutHalfPageDefinition;
      default:
        return null;
    }
  });

  const bg = root.items.find(
    i => i.type === BACKGROUND
  ) as BackgroundDefinition;
  if (bg) {
    bg.values.direction = { _: 'column', lg: 'row' };
  }

  return root;
};
